import { HOST_API } from 'src/config-global';
import { type OptionsMap } from 'src/types';

const CATEGORY_LIST_API_URI = '/api/category/list';

interface CategoryItem {
  id: string;
  name: string;
}

interface CategoryListResponse {
  totalCount: number;
  list: CategoryItem[];
}

async function fetchCategoryListRaw(): Promise<CategoryListResponse> {
  const response = await fetch(`${HOST_API}${CATEGORY_LIST_API_URI}`, {
    method: 'POST',
  });

  if (!response.ok) {
    let message = `${response.status}:${response.statusText}`;
    if (response.status < 500) {
      const responseData = await response.json();
      message = responseData.error;
    }
    throw new Error(message);
  }

  return response.json();
}

export async function fetchCategoryList(): Promise<CategoryListResponse> {
  return fetchCategoryListRaw();
}

export async function fetchCategoryListAsOptionsMap(): Promise<OptionsMap> {
  const data = await fetchCategoryListRaw();
  return Object.fromEntries(data.list.map(item => [item.id, item.name]));
}
